// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-41090232] .el-dialog--center .el-dialog__body {\n  padding: 10px 32px 0;\n}\n.fix-form .time-select[data-v-41090232] {\n  Width: 60px;\n  margin: 0 6px;\n}\n.fix-form .time-select[data-v-41090232] .el-input__inner {\n  padding-left: 10px;\n}\n.fix-form[data-v-41090232] .check-group {\n  margin-bottom: 10px;\n}\n.fix-form[data-v-41090232] .el-radio {\n  display: block;\n  line-height: 40px;\n}\n.fix-form[data-v-41090232] .el-radio .name-text {\n  color: #606266;\n}", ""]);
// Exports
module.exports = exports;
